import { get } from "svelte/store";
import settings from "$lib/state/settings";
import { getSession, resetSession } from "$lib/api/session";
import { currentApiURL, nextApiURL, PUBLIC_INSTANCES } from "$lib/api/api-url";
import type { Optional } from "$lib/types/generic";
import type { CobaltAPIResponse, CobaltErrorResponse, CobaltSaveRequestBody } from "$lib/types/api";

const getAuthorization = async () => {
    const processing = get(settings).processing;
    if (processing.enableCustomApiKey && processing.customApiKey.length > 0) {
        return `Api-Key ${processing.customApiKey}`;
    }

    const session = await getSession();

    if (session) {
        if ("error" in session) {
            if (session.error.code !== "error.api.auth.not_configured") {
                return session;
            }
        } else {
            return `Bearer ${session.token}`;
        }
    }
}

const request = async (requestBody: CobaltSaveRequestBody, justRetried = false) => {
    const authorization = await getAuthorization();

    if (authorization && typeof authorization !== "string") {
        return authorization;
    }

    let extraHeaders = {};
    if (authorization) {
        extraHeaders = { "Authorization": authorization };
    }

    let api = currentApiURL();
    let response: Optional<CobaltAPIResponse>;
    let attempts = 0;
    const maxAttempts = PUBLIC_INSTANCES.length;

    // BUCLE DE RESPALDO (Sin comprobaciones previas, ataque directo)
    while (attempts < maxAttempts) {
        try {
            console.log(`[Motor Trece12] Disparando a: ${api}`);
            response = await fetch(api, {
                method: "POST",
                redirect: "manual",
                signal: AbortSignal.timeout(15000), 
                body: JSON.stringify(requestBody),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    ...extraHeaders,
                },
            }).then(async r => {
                if (!r.ok && r.status !== 401) {
                    throw new Error(`Instancia rechazada: ${r.status}`);
                }
                return r.json();
            });
            break; // ¡Exito!
        } catch (e) {
            console.warn(`[Motor Trece12] Fallo en (${api}). Saltando al siguiente...`);
            api = nextApiURL();
            attempts++;
            response = undefined;
        }
    }

    if (!response) {
        return {
            status: "error",
            error: { code: "error.api.unreachable" }
        } as CobaltErrorResponse;
    }

    if (response?.status === 'error' && response?.error.code === 'error.api.auth.jwt.invalid' && !justRetried) {
        resetSession();
        await getAuthorization();
        return request(requestBody, true);
    }

    return response;
}

const probeCobaltTunnel = async (url: string) => {
    const request = await fetch(`${url}&p=1`).catch(() => {});
    if (request?.status === 200) {
        return request?.status;
    }
    return 0;
}

export default { request, probeCobaltTunnel }